<script setup lang="ts">
import useCurrencyInput from "vue-currency-input";

const props = defineProps<{
    value: number;
    options: object;
}>();

// biome-ignore lint/correctness/noUnusedVariables: Init Biome
const { formattedValue, inputRef } = useCurrencyInput(props.options);
</script>

<template>
    <input class="form-text" ref="inputRef" :value="formattedValue" />
</template>
